import * as React from "react";
import { CheckboxProps, DropdownProps, Form } from "semantic-ui-react";
import { LinkObject } from "@teamprevent/common/model";

import { ALL_GENERIC_CASE_TYPES } from "../model";
import { GenericCaseType } from "../../../genericCaseTypes/models";

interface Props {
    permissionsEnabled: boolean;
    allGenericCaseTypes: GenericCaseType[];
    selectedGenericCaseTypes: LinkObject[];
    onGenericCaseTypeChange: (genericCaseTypes: LinkObject[]) => void;
    onPermissionsEnabledChange: (value: boolean) => void;
}

const getAllValue = () => { return { id: ALL_GENERIC_CASE_TYPES, name: ALL_GENERIC_CASE_TYPES }; };

export const GenericCaseTypeEdit: React.FunctionComponent<Props> = ({
    permissionsEnabled,
    allGenericCaseTypes,
    selectedGenericCaseTypes,
    onGenericCaseTypeChange,
    onPermissionsEnabledChange }) =>
{
    const genericCaseTypeOptions = React.useMemo(() =>
        allGenericCaseTypes &&
        [
            { key: ALL_GENERIC_CASE_TYPES, value: ALL_GENERIC_CASE_TYPES, text: ALL_GENERIC_CASE_TYPES },
            ...allGenericCaseTypes.map(gct => ({ key: gct.id, value: gct.id, text: gct.name }))
        ],
    [allGenericCaseTypes]);

    const onSelectCheckboxChanged = React.useCallback((_, data: CheckboxProps) => {
        onPermissionsEnabledChange((data.checked ?? false));
    }, [onPermissionsEnabledChange]);

    const onGenericCaseTypeDropDownChange = React.useCallback((_, data: DropdownProps) => {
        const genericCaseTypeIds = data.value as string[];
        const genericCaseTypes = genericCaseTypeIds.map(gctId => {
            if (gctId === ALL_GENERIC_CASE_TYPES) {
                return getAllValue();
            }
            return allGenericCaseTypes.find(gct => gct.id === gctId);
        }).filter(gct => gct !== undefined) as LinkObject[];

        const lastAddedCaseType = genericCaseTypes[genericCaseTypes.length - 1];
        if (lastAddedCaseType?.id === ALL_GENERIC_CASE_TYPES) {
            onGenericCaseTypeChange([lastAddedCaseType]);
        }
        else if (genericCaseTypes[0]?.id === ALL_GENERIC_CASE_TYPES) {
            onGenericCaseTypeChange(genericCaseTypes.filter(gct => gct.id !== ALL_GENERIC_CASE_TYPES));
        }
        else {
            onGenericCaseTypeChange(genericCaseTypes);
        }
    }, [allGenericCaseTypes, onGenericCaseTypeChange]);

    if (!genericCaseTypeOptions)
    {
        return null;
    }

    return (
        <>
            <Form.Checkbox
                label={"Generic"}
                checked={permissionsEnabled}
                onChange={onSelectCheckboxChanged}
            />
            <Form.Dropdown
                selection
                multiple
                search
                required
                options={genericCaseTypeOptions}
                onChange={onGenericCaseTypeDropDownChange}
                value={selectedGenericCaseTypes.map(org => org.id)}
            />
        </>
    );
};
